export const locationOptions = [
    'Baden-Württemberg',
    'Bayern',
    'Berlin',
    'Brandenburg',
    'Bremen',
    'Hamburg',
    'Hessen',
    'Mecklenburg-Vorpommern',
    'Niedersachsen',
    'Nordrhein-Westfalen',
    'Rheinland-Pfalz',
    'Saarland',
    'Sachsen',
    'Sachsen-Anhalt',
    'Schleswig-Holstein',
    'Thüringen',
    'Ich wohne im Ausland'
];
export const shirtSizes = [
    'XS',
    'S',
    'M',
    'L',
    'XL'
];
export const teamPostions = [
    'Stürmer',
    'Mittelfeldspieler',
    'Verteidiger',
    'Torwart'
];
export const countryOptions = [
    'Belgien',
    'Bulgarien',
    'Dänemark',
    'Estland',
    'Finnland',
    'Frankreich',
    'Griechenland',
    'Irland',
    'Italien',
    'Kroatien',
    'Lettland',
    'Litauen',
    'Luxemburg',
    'Malta',
    'Niederlande',
    'Polen',
    'Portugal',
    'Rumänien',
    'Schweden',
    'Slowakei',
    'Slowenien',
    'Spanien',
    'Tschechische Republik',
    'Ungarn',
    'Zypern',
    'Österreich'
];
export const uiStrings = {
    headlines: {
        aboutYou: 'Über Dich:',
        footballExperience: 'Deine Fußballerfahrung',
        socialLinks: 'Zeig uns, was Du kannst'
    },
    fieldLabels: {
        givenName: 'Vorname',
        familyName: 'Nachname',
        birthday: 'Geburtsdatum',
        email: 'E-Mail',
        telephone: 'Telefon',
        shirtSize: 'Kleidergröße',
        state: 'Dein Bundesland',
        country: 'Land',
        teamType: 'Teamtyp',
        yourPosition: 'Deine Position',
        otherLeagues: 'Welche sonstige Spielklasse?',
        currentClub: 'In welchem Verein spielst Du',
        availabilityFrom: 'Ich bin verfügbar am',
        activeExperience: 'Wie bist Du gerade aktiv',
        highestExperience: 'Deine höchstgespielte Spielklasse',
        league: 'Liga',
        weight: 'Gewicht',
        height: 'Körpergröße'
    },
    tooltipMessages: {
        phone: "Es ist zwar freiwillig, die Nummer anzugeben. Aber wie sollen Dich Poldi oder Mats denn sonst anrufen, wenn es mit der Baller League klappt?",
        clothes: "Warum wir Deine Größe brauchen? Easy: Kein Spiel ohne Trikots. Und die sollen am Ende doch passen, oder?",
        experience: "Deine Prime-Liga: / Dein höchstes Level bisher:",
        birthday: "Du musst mindestens 18 Jahre sein, um teilnehmen zu können.",
        highlight: "Hier kannst du deine besten Szenen hochladen. Egal ob via YouTube, Google Drive, Dropbox oder WeTransfer: hier ist Platz für deine Links. Achte darauf, dass die Filme gängige Formate haben.",
        achievments: "Schreibe hier alles rein, was wir noch über deine Fußballkarriere wissen sollten. Torschützenkönig in der Kreisklasse? Fünf Minuten 2. Liga Erfahrung? Erzähle uns deine Geschichten.",
        dates: "Teile uns bitte mit, an welchem Tag du für den Combine verfügbar bist."
    }
};
//# sourceMappingURL=constants.js.map